/**
 * Created by Ning Jiang on 10/10/2018.
 */

import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {BitmapWinCountUp} from "@nolimitcity/slot-game/bin/game/winpresentation/countup/BitmapWinCountUp";
import {Power3, Timeline, TimelineLite, TweenLite} from "gsap";
import {FITHSoundManager} from "../../sound/FITHSoundManager";
import {FITHSoundConfig} from "../../FITHSoundConfig";
import {WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {FITHGameConfig} from "../../FITHGameConfig";

export class FITHInitialWinCountUp extends BitmapWinCountUp {
    private _countUpEndSoundPlayed: boolean = false;
    private _winType: WinRatioType | undefined;

    constructor() {
        super({
            font: {
                name: "NumbersWinCountUp",
                size: 50
            },
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
    }

    public getCountUpAnimation(from: number, to: number, duration: number, type: WinRatioType | undefined): Timeline {
        const oriNumber: number = MathHelper.floorToDecimals(to, 2);
        const timeline: TimelineLite = new TimelineLite();

        this._winType = type;

        timeline.add([
            () => {
                this._countUp.visible = true;
                this._countUpContainer.scale.set(1, 1);
                if (duration > 0.01) {
                    // #220, medium and large win only
                    FITHSoundManager.playCountUp();

                    // #217
                    this._countUp.alpha = 0;
                    TweenLite.to(this._countUp, 0.5, {alpha: 1});
                } else {
                    this._countUp.alpha = 1;
                }

                this._countUpEndSoundPlayed = false;
            },
            this._countUp.getCountUpAnimation(from, oriNumber, {duration: duration, ease: Power3.easeInOut})
        ]);

        // #220
        timeline.add(() => {
            FITHSoundManager.stopSoundEffect(FITHSoundConfig.instance.COUNT_UP);

            this.playEndSound();
        });
        return timeline;
    }

    public abort(endValue: number, isAborted: boolean, isBigWin: boolean): Timeline | null {
        if (isBigWin) {
            return null;
        }

        return super.abort(endValue, isAborted);
    }

    public getEndingAnimation(endValue: number): Timeline {
        const timeline: TimelineLite = new TimelineLite();

        // #220
        timeline.add(() => {
            FITHSoundManager.stopSoundEffect(FITHSoundConfig.instance.COUNT_UP);

            this.playEndSound();
        });

        timeline.add(this._countUp.getCountUpAnimation(endValue, endValue, {duration: 0.01}));
        timeline.add(TweenLite.to(this._countUp, 0.5, {alpha: 0}), `+=1`); // stay a while after count up.

        return timeline;
    }

    protected getAbortAnimation(endValue: number): Timeline {
        const timeline: TimelineLite = new TimelineLite();
        timeline.add(
            () => {
                this._countUp.alpha = 1;
                this._countUp.visible = true;
            }
        );
        return timeline;
    }

    private playEndSound(): void {
        // #353
        if (FITHGameConfig.instance.WIN_BELOW_STAKE) {
            return;
        }

        if (!this._countUpEndSoundPlayed) {
            this._countUpEndSoundPlayed = true;

            // #220
            if (this._winType === WinRatioType.TINY) {
                FITHSoundManager.playCountUpEndsTiny();
            } else if (this._winType === WinRatioType.SMALL) {
                FITHSoundManager.playCountUpEndsSmall();
            } else if (this._winType === WinRatioType.MEDIUM) {
                FITHSoundManager.playCountUpEndsMedium();
            } else if (this._winType === WinRatioType.LARGE) {
                FITHSoundManager.playCountUpEndsLarge();
            }
        }
    }
}